import { render, staticRenderFns } from "./app-bottom-button.vue?vue&type=template&id=57fd5224&scoped=true&"
import script from "./app-bottom-button.vue?vue&type=script&lang=js&"
export * from "./app-bottom-button.vue?vue&type=script&lang=js&"
import style0 from "./app-bottom-button.vue?vue&type=style&index=0&id=57fd5224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fd5224",
  null
  
)

export default component.exports